  
function scrollEvAA(leftArrowAA, rightArrowAA, reviewsliderAA) {
  if (reviewsliderAA.scrollLeft <= 0) {
    // leftArrowAA.classList.add("arrow-inactive");
  } else {
    // leftArrowAA.classList.remove("arrow-inactive");
  }
  if (reviewsliderAA.scrollLeft >= reviewsliderAA.scrollWidth - reviewsliderAA.offsetWidth - 1) {
    // rightArrowAA.classList.add("arrow-inactive");
  } else {
    // rightArrowAA.classList.remove("arrow-inactive");
  }
}



function clicleftArrowAA(reviewsliderAA, rectListAA) {
  let shiftScrollAA;
  for (let i = 0; i < rectListAA.length; i++) {
    if (reviewsliderAA.scrollLeft > rectListAA[rectListAA.length - 1]) {
      shiftScrollAA = rectListAA[rectListAA.length - 1];
    } else if (
      reviewsliderAA.scrollLeft > rectListAA[i] &&
      reviewsliderAA.scrollLeft <= rectListAA[i + 1]
    ) {
      shiftScrollAA = rectListAA[i];
    }
  }
  reviewsliderAA.scrollTo({
    left: shiftScrollAA,
    behavior: "smooth"
  });
}

function clickRightAA(reviewsliderAA, rectListAA) {
  let shiftScrollAA;
  for (let i = 0; i < rectListAA.length; i++) {
    if (
      reviewsliderAA.scrollLeft >= rectListAA[i] - 1 &&
      reviewsliderAA.scrollLeft < rectListAA[i + 1]
    ) {
      shiftScrollAA = rectListAA[i + 1];
    }
  }
  reviewsliderAA.scrollTo({
    left: shiftScrollAA,
    behavior: "smooth"
  });
}

function listRectreviewsliderAA(reviewsliderAANumber, reviewsliderAAs) {
  let divsAA = reviewsliderAAs[reviewsliderAANumber]?.getElementsByClassName("reviewsliderAA-item") || [];
  let rectListAA = [];
  let rectGaucheAA = reviewsliderAAs[reviewsliderAANumber].getBoundingClientRect().left;

  for (let i = 0; i < divsAA.length; i++) {
    let rectAA = divsAA[i].getBoundingClientRect();
    rectListAA.push(rectAA.left - rectGaucheAA);
  }

  for (let i = rectListAA.length - 1; i >= 0; i--) {
    rectListAA[i] = rectListAA[i] - rectListAA[0];
  }
  return rectListAA;
}

function autoSlidePosLeftAA(reviewsliderAANumber, reviewsliderAAs, leftArrowAAs) {
  let rectListAA = listRectreviewsliderAA(reviewsliderAANumber, reviewsliderAAs);
  leftArrowAAs[reviewsliderAANumber].addEventListener("click", () => {
    clicleftArrowAA(reviewsliderAAs[reviewsliderAANumber], rectListAA);
  });
}

function autoSlidePosRightAA(reviewsliderAANumber, reviewsliderAAs, rightArrowAAs) {
  let rectListAA = listRectreviewsliderAA(reviewsliderAANumber, reviewsliderAAs);
  rightArrowAAs[reviewsliderAANumber].addEventListener("click", () => {
    clickRightAA(reviewsliderAAs[reviewsliderAANumber], rectListAA);
  });
}


// function autoScrollRightAA(reviewsliderAA, currentrectListAA) {
//   let shiftScrollAA;
//   for (let i = 0; i < currentrectListAA.length; i++) {
//     if (
//       reviewsliderAA.scrollLeft >= currentrectListAA[i] - 1 &&
//       reviewsliderAA.scrollLeft < currentrectListAA[i + 1]
//     ) {
//       shiftScrollAA = currentrectListAA[i + 1];
//     }
//   }

//   if (shiftScrollAA === undefined) {
//     // If shiftScrollAA is undefined, it means the end of the carousel is reached
//     // Scroll back to the beginning
//     shiftScrollAA = 0;
//   }

//   reviewsliderAA.scrollTo({
//     left: shiftScrollAA,
//     behavior: "smooth"
//   });
// }


  
function scrollEvBB(leftArrowBB, rightArrowBB, reviewsliderBB) {
  if (reviewsliderBB.scrollLeft <= 0) {
    // leftArrowBB.classList.add("arrow-inactive");
  } else {
    // leftArrowBB.classList.remove("arrow-inactive");
  }
  if (reviewsliderBB.scrollLeft >= reviewsliderBB.scrollWidth - reviewsliderBB.offsetWidth - 1) {
    // rightArrowBB.classList.add("arrow-inactive");
  } else {
    // rightArrowBB.classList.remove("arrow-inactive");
  }
}



function clicleftArrowBB(reviewsliderBB, rectListBB) {
  let shiftScrollBB;
  for (let i = 0; i < rectListBB.length; i++) {
    if (reviewsliderBB.scrollLeft > rectListBB[rectListBB.length - 1]) {
      shiftScrollBB = rectListBB[rectListBB.length - 1];
    } else if (
      reviewsliderBB.scrollLeft > rectListBB[i] &&
      reviewsliderBB.scrollLeft <= rectListBB[i + 1]
    ) {
      shiftScrollBB = rectListBB[i];
    }
  }
  reviewsliderBB.scrollTo({
    left: shiftScrollBB,
    behavior: "smooth"
  });
}

function clickRightBB(reviewsliderBB, rectListBB) {
  let shiftScrollBB;
  for (let i = 0; i < rectListBB.length; i++) {
    if (
      reviewsliderBB.scrollLeft >= rectListBB[i] - 1 &&
      reviewsliderBB.scrollLeft < rectListBB[i + 1]
    ) {
      shiftScrollBB = rectListBB[i + 1];
    }
  }
  reviewsliderBB.scrollTo({
    left: shiftScrollBB,
    behavior: "smooth"
  });
}

function listRectreviewsliderBB(reviewsliderBBNumber, reviewsliderBBs) {
  let divsBB = reviewsliderBBs[reviewsliderBBNumber].getElementsByClassName("reviewsliderBB-item");
  let rectListBB = [];
  let rectGaucheBB = reviewsliderBBs[reviewsliderBBNumber].getBoundingClientRect().left;

  for (let i = 0; i < divsBB.length; i++) {
    let rectBB = divsBB[i].getBoundingClientRect();
    rectListBB.push(rectBB.left - rectGaucheBB);
  }

  for (let i = rectListBB.length - 1; i >= 0; i--) {
    rectListBB[i] = rectListBB[i] - rectListBB[0];
  }
  return rectListBB;
}

function autoSlidePosLeftBB(reviewsliderBBNumber, reviewsliderBBs, leftArrowBBs) {
  let rectListBB = listRectreviewsliderBB(reviewsliderBBNumber, reviewsliderBBs);
  leftArrowBBs[reviewsliderBBNumber].addEventListener("click", () => {
    clicleftArrowBB(reviewsliderBBs[reviewsliderBBNumber], rectListBB);
  });
}

function autoSlidePosRightBB(reviewsliderBBNumber, reviewsliderBBs, rightArrowBBs) {
  let rectListBB = listRectreviewsliderBB(reviewsliderBBNumber, reviewsliderBBs);
  rightArrowBBs[reviewsliderBBNumber].addEventListener("click", () => {
    clickRightBB(reviewsliderBBs[reviewsliderBBNumber], rectListBB);
  });
}


// function autoScrollRightBB(reviewsliderBB, currentrectListBB) {
//   let shiftScrollBB;
//   for (let i = 0; i < currentrectListBB.length; i++) {
//     if (
//       reviewsliderBB.scrollLeft >= currentrectListBB[i] - 1 &&
//       reviewsliderBB.scrollLeft < currentrectListBB[i + 1]
//     ) {
//       shiftScrollBB = currentrectListBB[i + 1];
//     }
//   }

//   if (shiftScrollBB === undefined) {
//     // If shiftScrollBB is undefined, it means the end of the carousel is reached
//     // Scroll back to the beginning
//     shiftScrollBB = 0;
//   }

//   reviewsliderBB.scrollTo({
//     left: shiftScrollBB,
//     behavior: "smooth"
//   });
// }


function scrollEvCC(leftArrowCC, rightArrowCC, reviewsliderCC) {
  if (reviewsliderCC.scrollLeft <= 0) {
    // leftArrowCC.classList.add("arrow-inactive");
  } else {
    // leftArrowCC.classList.remove("arrow-inactive");
  }
  if (reviewsliderCC.scrollLeft >= reviewsliderCC.scrollWidth - reviewsliderCC.offsetWidth - 1) {
    // rightArrowCC.classList.add("arrow-inactive");
  } else {
    // rightArrowCC.classList.remove("arrow-inactive");
  }
}



function clicleftArrowCC(reviewsliderCC, rectListCC) {
  let shiftScrollCC;
  for (let i = 0; i < rectListCC.length; i++) {
    if (reviewsliderCC.scrollLeft > rectListCC[rectListCC.length - 1]) {
      shiftScrollCC = rectListCC[rectListCC.length - 1];
    } else if (
      reviewsliderCC.scrollLeft > rectListCC[i] &&
      reviewsliderCC.scrollLeft <= rectListCC[i + 1]
    ) {
      shiftScrollCC = rectListCC[i];
    }
  }
  reviewsliderCC.scrollTo({
    left: shiftScrollCC,
    behavior: "smooth"
  });
}

function clickRightCC(reviewsliderCC, rectListCC) {
  let shiftScrollCC;
  for (let i = 0; i < rectListCC.length; i++) {
    if (
      reviewsliderCC.scrollLeft >= rectListCC[i] - 1 &&
      reviewsliderCC.scrollLeft < rectListCC[i + 1]
    ) {
      shiftScrollCC = rectListCC[i + 1];
    }
  }
  reviewsliderCC.scrollTo({
    left: shiftScrollCC,
    behavior: "smooth"
  });
}

function listRectreviewsliderCC(reviewsliderCCNumber, reviewsliderCCs) {
  let divsCC = reviewsliderCCs[reviewsliderCCNumber].getElementsByClassName("reviewsliderCC-item");
  let rectListCC = [];
  let rectGaucheCC = reviewsliderCCs[reviewsliderCCNumber].getBoundingClientRect().left;

  for (let i = 0; i < divsCC.length; i++) {
    let rectCC = divsCC[i].getBoundingClientRect();
    rectListCC.push(rectCC.left - rectGaucheCC);
  }

  for (let i = rectListCC.length - 1; i >= 0; i--) {
    rectListCC[i] = rectListCC[i] - rectListCC[0];
  }
  return rectListCC;
}

function autoSlidePosLeftCC(reviewsliderCCNumber, reviewsliderCCs, leftArrowCCs) {
  let rectListCC = listRectreviewsliderCC(reviewsliderCCNumber, reviewsliderCCs);
  leftArrowCCs[reviewsliderCCNumber].addEventListener("click", () => {
    clicleftArrowCC(reviewsliderCCs[reviewsliderCCNumber], rectListCC);
  });
}

function autoSlidePosRightCC(reviewsliderCCNumber, reviewsliderCCs, rightArrowCCs) {
  let rectListCC = listRectreviewsliderCC(reviewsliderCCNumber, reviewsliderCCs);
  rightArrowCCs[reviewsliderCCNumber].addEventListener("click", () => {
    clickRightCC(reviewsliderCCs[reviewsliderCCNumber], rectListCC);
  });
}


function autoScrollRightCC(reviewsliderCC, currentrectListCC) {
  let shiftScrollCC;
  for (let i = 0; i < currentrectListCC.length; i++) {
    if (
      reviewsliderCC.scrollLeft >= currentrectListCC[i] - 1 &&
      reviewsliderCC.scrollLeft < currentrectListCC[i + 1]
    ) {
      shiftScrollCC = currentrectListCC[i + 1];
    }
  }

  if (shiftScrollCC === undefined) {
    // If shiftScrollCC is undefined, it means the end of the carousel is reached
    // Scroll back to the beginning
    shiftScrollCC = 0;
  }

  reviewsliderCC.scrollTo({
    left: shiftScrollCC,
    behavior: "smooth"
  });
}



  
window.addEventListener('load', () => {
  let leftArrowAAs = document.getElementsByClassName("left-arrowAA");
  let rightArrowAAs = document.getElementsByClassName("right-arrowAA");
  let reviewsliderAAs = document.getElementsByClassName("reviewsliderAA");
  let leftArrowBBs = document.getElementsByClassName("left-arrowBB");
  let rightArrowBBs = document.getElementsByClassName("right-arrowBB");
  let reviewsliderBBs = document.getElementsByClassName("reviewsliderBB");
  let leftArrowCCs = document.getElementsByClassName("left-arrowCC");
  let rightArrowCCs = document.getElementsByClassName("right-arrowCC");
  let reviewsliderCCs = document.getElementsByClassName("reviewsliderCC");

  function recomputeArrowPositions() {
    for (let i = 0; i < leftArrowCCs.length; i++) autoSlidePosLeftCC(i, reviewsliderCCs, leftArrowCCs);
    for (let i = 0; i < rightArrowCCs.length; i++) autoSlidePosRightCC(i, reviewsliderCCs, rightArrowCCs);
    for (let i = 0; i < leftArrowBBs.length; i++) autoSlidePosLeftBB(i, reviewsliderBBs, leftArrowBBs);
    for (let i = 0; i < rightArrowBBs.length; i++) autoSlidePosRightBB(i, reviewsliderBBs, rightArrowBBs);
    for (let i = 0; i < leftArrowAAs.length; i++) autoSlidePosLeftAA(i, reviewsliderAAs, leftArrowAAs);
    for (let i = 0; i < rightArrowAAs.length; i++) autoSlidePosRightAA(i, reviewsliderAAs, rightArrowAAs);
  }

  recomputeArrowPositions();
  window.addEventListener('resize', recomputeArrowPositions);

  for (let i = 0; i < reviewsliderCCs.length; i++) {
    reviewsliderCCs[i].addEventListener("scroll", () => {
      scrollEvCC(leftArrowCCs[i], rightArrowCCs[i], reviewsliderCCs[i]);
    });

    let currentrectListCC = listRectreviewsliderCC(i, reviewsliderCCs);

    let autoScrollInterval = setInterval(() => {
      autoScrollRightCC(reviewsliderCCs[i], currentrectListCC);
    }, 3000);

    reviewsliderCCs[i].autoScrollInterval = autoScrollInterval;
  }

  for (let i = 0; i < reviewsliderBBs.length; i++) {
    reviewsliderBBs[i].addEventListener("scroll", () => {
      scrollEvBB(leftArrowBBs[i], rightArrowBBs[i], reviewsliderBBs[i]);
    });

    let currentrectListBB = listRectreviewsliderBB(i, reviewsliderBBs);
  }

  // for (let i = 0; i < reviewsliderAAs.length; i++) {
  //   reviewsliderAAs[i].addEventListener("scroll", () => {
  //     scrollEvAA(leftArrowAAs[i], rightArrowAAs[i], reviewsliderAAs[i]);
  //   });

  //   // Calculate rectListAA for each reviewsliderAA and store it in a variable
  //   let currentrectListAA = listRectreviewsliderAA(i, reviewsliderAAs);

  //   // Set up interval for auto-scrolling
  //   let autoScrollInterval = setInterval(() => {
  //     autoScrollRightAA(reviewsliderAAs[i], currentrectListAA);
  //   }, 3000); // Adjust the interval time (in milliseconds) as needed

  //   // Attach interval to the reviewsliderAA element for later clearance if needed
  //   reviewsliderAAs[i].autoScrollInterval = autoScrollInterval;
  // }
});

